export class Enums {
    static get TaxesType() {
        return {
            UserDictate: 0,
            Model: 1,
            Seller: 2,
            InvestmentManagement: 3
        }
    }
    static get HoaType() {
        return {
            UserDictate: 0,
            Model: 1,
            Seller: 2,
            InvestmentManagement: 3
        }
    }
    static get RepairEstimateType() {
        return {
            UserDictate: 0,
            Model: 1,
            Inspection: 2,
            ProposedRepairBidAmount: 3,
            Fallback: 4
        }
    }
    static get RentType() {
        return {
            UserDictate: 0,
            CompsMin: 1,
            CompsMax: 2,
            CompsAvg: 3,
            Seller: 4,
            InvestmentManagement: 5,
            Model: 6
        }
    }
    static get AfterRepairValueType() {
        return {
            UserDictate: 0,
            CompsMin: 1,
            CompsMax: 2,
            CompsAvg: 3,
            Seller: 4,
            InvestmentManagement: 5,
            Model: 6
        }
    }
    static get ClosingCostsType() {
        return {
            UserDictate: 0,
            Model: 1
        }
    }
    static get BidPriceType() {
        return {
            UserDictate: 0,
            Model: 1,
            TargetBidPriceRental: 2,  // We don't have TargetBidPriceRental as a radio option anymore, but we keep it here for backward compatibility
            TargetBidPriceRetail: 3,  // We don't have TargetBidPriceRetail as a radio option anymore, but we keep it here for backward compatibility
            CounterAmount: 5,
            PurchasePrice: 6,
            NormalAvm: 7,
            UnderContractAmount: 8,
            CounterConcessionAmount: 9
        }
    }
    static get LotValueType() {
        return {
            UserDictate: 0
        }
    }
    static get AsIsValueType() {
        return {
            UserDictate: 0
        }
    }
    static get ReducedRentType() {
        return {
            UserDictate: 0
        }
    }
    static get ReducedAfterRepairValueType() {
        return {
            UserDictate: 0
        }
    }
}